import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/loader.json'; // Adjust the path as needed

const ContainerLoader = () => {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	return (
		<div className="in-container-loader">
			<div className="loader-wrap">

				<Lottie options={defaultOptions}/>
			</div>
		</div>
	);
};

export default ContainerLoader;
